export default __webpack_public_path__ + "static/media/LION.985c95c1.gif";